import { css } from "@emotion/css";
import { CircularProgress, ExternalLink } from "@octopusdeploy/design-system-components";
import { CheckCircleIcon, ExclamationCircleIcon } from "@octopusdeploy/design-system-icons";
import { space, themeTokens } from "@octopusdeploy/design-system-tokens";
import type { ArgoCDGatewayHealthStatus } from "@octopusdeploy/octopus-server-client";
import { ExternalLinkSlugs } from "~/areas/infrastructure/components/ArgoCDInstances/ArgoCDConstants";
type GatewayInstallationStatusProps = {
    healthStatus: ArgoCDGatewayHealthStatus;
    isFound: boolean;
};
export const GatewayInstallationStatus = (props: GatewayInstallationStatusProps) => {
    const { healthStatus, isFound } = props;
    return (<div className={styles.statusContainer}>
            <InstallationStatusRow successLabel="Gateway registered with Octopus" failureLabel="Failed to register with Octopus" inProgressLabel="Registering with Octopus" inProgress={!isFound} successful={isFound}/>
            <InstallationStatusRow successLabel="Connected to Octopus" failureLabel="Failed to connect to Octopus" inProgressLabel="Connecting to Octopus" inProgress={healthStatus === "Unknown"} successful={healthStatus !== "Unavailable"}/>
            <InstallationStatusRow successLabel="Connected to Argo CD" failureLabel="Failed to connect to Argo CD" inProgressLabel="Connecting to Argo CD" inProgress={healthStatus === "Unknown"} successful={healthStatus !== "ArgoCDConnectionIssues" && healthStatus !== "Unavailable"}/>

            {(healthStatus === "ArgoCDConnectionIssues" || healthStatus === "Unavailable") && <ExternalLink href={ExternalLinkSlugs.ArgoGatewayTroubleshootingDocs}>Follow the troubleshooting guide</ExternalLink>}
        </div>);
};
type InstallationStatusRowProps = {
    failureLabel: string;
    successLabel: string;
    inProgressLabel: string;
    inProgress: boolean;
    successful: boolean;
};
const InstallationStatusRow = (props: InstallationStatusRowProps) => {
    const { inProgressLabel, successLabel, failureLabel, successful, inProgress } = props;
    if (inProgress) {
        return (<div className={styles.statusRow}>
                <CircularProgress size="small" aria-hidden="true"/>
                <span>{inProgressLabel}</span>
            </div>);
    }
    if (!inProgress && successful) {
        return (<div className={styles.statusRow}>
                <CheckCircleIcon size={24} color={themeTokens.color.icon.success}/>
                <span>{successLabel}</span>
            </div>);
    }
    if (!inProgress && !successful) {
        return (<div className={styles.statusRow}>
                <ExclamationCircleIcon size={24} color={themeTokens.color.icon.danger}/>
                <span>{failureLabel}</span>
            </div>);
    }
    return <></>;
};
const styles = {
    statusContainer: css({
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: space[16],
        alignSelf: "stretch",
    }),
    statusRow: css({
        display: "flex",
        alignItems: "center",
        gap: space[8],
    }),
};
